import type { Theme } from "@mui/material/styles";
import type { AppSx } from "../types";

export interface ChartTypeIconComponentStyles {
  svgWrap: AppSx;
}

export function buildChartTypeIconComponentStyles(_theme: Theme): ChartTypeIconComponentStyles {
  return {
    svgWrap: { display: "block", flexShrink: 0 },
  };
}
